import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rfid",
  "use": "rfid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"rfid\"><path d=\"M23.2.8H16V0h8v8h-.8zM.8.8V8H0V0h8v.8zM23.2 23.2V16h.8v8h-8v-.8zM0 23.9v-8h.8v7.3H8v.8H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol